import { format24HourTime, formatBookingId } from '../../../../../utils/supportHelpers';

const ChatListItem = ({ chat, isSelected, onSelect }) => {
  const unread = chat.unread_agent_count || 0;
  const bookingIdFormatted = formatBookingId(chat.booking_id);

  return (
    <button
      onClick={() => onSelect(chat.booking_id, chat.guest_name)}
      className={`w-full p-4 flex flex-col text-left transition-all cursor-pointer ${
        isSelected
          ? 'bg-[#067978]/5 border-l-4 border-l-[#067978]'
          : 'hover:bg-gray-50/80'
      }`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 flex-1 min-w-0 mr-2">
          <span className="text-sm md:text-[15px] font-bold text-slate-800 truncate flex-1">
            {chat.guest_name || 'Traveller'}
          </span>
          <span className="text-[10px] font-bold text-[#067978] bg-teal-50 border border-teal-100 px-2 py-0.5 rounded-full font-mono whitespace-nowrap lowercase">
            ID: {bookingIdFormatted}
          </span>
        </div>
        <span className="text-[10px] font-bold text-gray-400 whitespace-nowrap">
          {format24HourTime(chat.last_message_at || chat.updatedAt)}
        </span>
      </div>

      <div className="flex items-center justify-between mt-1.5">
        <p
          className={`text-[13px] truncate flex-1 mr-2 ${
            unread > 0 ? 'font-bold text-gray-900' : 'text-slate-500 font-medium'
          }`}
        >
          {chat.last_message || 'Active chat thread'}
        </p>
        {unread > 0 && (
          <span className="w-5 h-5 flex items-center justify-center bg-[#067978] text-white rounded-full text-[10px] font-black shadow-sm shadow-teal-900/10">
            {unread}
          </span>
        )}
      </div>
    </button>
  );
};

export default ChatListItem;
